import { normalizeLocale } from 'src/i18n/config'
import { getLangChangerOptions } from 'src/i18n/client/getLangChangerOptions'

const stripQuery = (path) => path.split(/[?#]/)[0]

const toAbsoluteUrl = (origin, path) => `${origin}${stripQuery(path).replace(/\/+$/, '') || '/'}`

// Wersje językowe strony dla <link rel="alternate" hreflang>. Bez odpowiednika w innym języku
// albo w podglądzie (token w ścieżce) nie zwracamy nic — hreflang musi wskazywać pary stron.
export const getHreflangLinks = ({ origin, locale, pathname, defaultLocale, path, options }) => {
  const currentLocale = normalizeLocale(locale)

  if (!origin || !currentLocale || !pathname) {
    return []
  }

  const alternates = getLangChangerOptions({ path, options }, currentLocale)

  if (alternates.length === 0 || alternates.some(({ path: alternatePath }) => alternatePath.includes('token='))) {
    return []
  }

  const links = [{ locale: currentLocale, path: pathname }, ...alternates].map(({ locale: hrefLang, path }) => ({
    hrefLang,
    href: toAbsoluteUrl(origin, path),
  }))
  const defaultLink = links.find(({ hrefLang }) => hrefLang === normalizeLocale(defaultLocale))

  return defaultLink ? [...links, { hrefLang: 'x-default', href: defaultLink.href }] : links
}
